(function () {
  'use strict';
  if (window.__MYX_SHAPE_TRANSITION__) return;
  window.__MYX_SHAPE_TRANSITION__ = true;
  // Native option clicks apply immediately. Do not hide the preview, queue clicks,
  // or lock/fade the option panels while the next selection is rendered.
  var sizeSelector = '[data-category-id="Zs0mISKbbkrsanNymAIa6Zqf"], [data-category-id="CQ5DSHGSBYKcjbeq1b8rf7MU"]';

  var hoverMode = '';
  var hoverStyle = document.createElement('style');
  hoverStyle.textContent = 'body[data-myx-hover-label="size"] [role="tooltip"],body[data-myx-hover-label="size"] .Polaris-Tooltip{display:none!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label{font-size:0!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label>*{display:none!important}' +
    'body[data-myx-hover-label="rgb"] .Polaris-Tooltip__Label::after{content:"RGB"!important;font-size:13px!important;line-height:1.4!important}';
  document.head.appendChild(hoverStyle);
  function hover(event) {
    var target = event.target.closest && event.target.closest('#product-builder .cpb-option,#product-builder .option');
    var next = target && target.closest(sizeSelector) ? 'size' : target && (/^RGB$/i.test(target.getAttribute('data-myx-option-caption') || target.getAttribute('data-myx-choice-label') || '') || /^Color option RGB$/i.test(target.getAttribute('aria-label') || '') || /^RGB$/i.test((target.querySelector('.cpb-option-label') || target).textContent.trim())) ? 'rgb' : '';
    if (next !== hoverMode) { hoverMode = next; if (next) document.body.dataset.myxHoverLabel = next; else document.body.removeAttribute('data-myx-hover-label'); }
    if (target && next) target.querySelectorAll('[title]').forEach(function (e) { if (e.title !== 'Most popular') { if (next === 'rgb') e.title = 'RGB'; else e.removeAttribute('title'); } });
  }
  document.addEventListener('pointerover', hover, true);
  document.addEventListener('focusin', hover, true);
})();
